<template>
  <Modal :title="title" :showModal="showModal" class="edit-schedule-template-form large" @submit="submit">
    <template v-slot:body>
      <div class="choose-template position-relative col-12 p-0 mt-3 d-flex flex-wrap">
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 font-weight-bold">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="changeName" />
        </div>
        <div class="position-relative form-group col-6">
          <label class="col-12 mb-0 p-0 font-weight-bold">Account name*</label>
          <Select class="mt-2" source="sale-account/search" :value="data.account_id" @changeValue="changeAccount"></Select>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0 font-weight-bold">Local Category*</label>
          <Select class="mt-2" source="term/search" :value="data.term_id" @changeValue="changeTerm"></Select>
        </div>
        <div class="position-relative form-group col-12 d-flex align-items-center">
          <label class="m-0 font-weight-bold">Share this template</label>
          <div class="togglebox-container ml-2">
            <input type="checkbox" name="shared" :checked="data.shared" @change.stop.prevent="changeShared" />
            <div class="slider"></div>
          </div>
        </div>
      </div>
      <component :is="modal" :config="modalConfig()" @close="$emit('close', $event)"></component>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      modal: 'Black'
    }
  },
  computed: {
    title() {
      return 'Edit Schedule'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    scheduleId() {
      return this.config?.data?._id
    },
    getUri() {
      return `schedule-template/get/${this.scheduleId}`
    },
    submitUri() {
      return `schedule-template/update/${this.scheduleId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    modalConfig() {
      return {
        action: this.action,
        storeId: this.storeId,
        scheduleId: this.scheduleId
      }
    },
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeAccount(value, args) {
      let modal = `${_.pascalCase(args.selected.platform || '')}.Schedule.ScheduleTemplate.Edit`
      if (this.$options.components[modal] == undefined) {
        this.modal = 'Black'
        this.$util.notify({
          text: 'Platforms not supported!',
          status: 'error'
        })
      } else {
        this.modal = modal
      }
      this.store.commit('account_id', value)
    },
    changeTerm(value) {
      this.store.commit('term_id', value)
    },
    changeShared(e) {
      this.store.commit('shared', Number(e.target.checked))
    },
    setUpData(rawData) {
      let platform = _.pascalCase(rawData.data.platform || '')
      let action = _.pascalCase(this.action)
      let modal = `${platform}.Schedule.ScheduleTemplate.${action}`
      if (this.$options.components[modal] == undefined) {
        this.$options.components[modal] = this.$util.requireOrNull(`/platforms/${platform}/Schedule/ScheduleTemplate/Modal/${action}.vue`)
      }
      if (rawData.status == 'success' && this.$options.components[modal] !== null) {
        this.showModal = true
        this.store.commit('', rawData.data)
        this.modal = modal
      } else {
        this.$emit('close')
        this.$util.notify({
          text: 'Platforms not supported!',
          status: 'error'
        })
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
